import React, { PropsWithChildren } from "react";
import {
    Accordion,
    AccordionHeader,
    AccordionPanel,
} from "@evidenceb/athena-common/design-system/Accordion";
interface MobileContainerProps extends PropsWithChildren {
    label: string;
    className?: string;
}

const MobileContainer = ({
    label,
    className,
    children,
}: MobileContainerProps) => {
    return (
        <Accordion className={className}>
            {(accordionProps) => (
                <>
                    <AccordionHeader
                        {...accordionProps}
                        container="h3"
                        className="teacher-playlist-send__mobile-accordion"
                    >
                        {label}
                    </AccordionHeader>
                    <AccordionPanel {...accordionProps}>
                        {children}
                    </AccordionPanel>
                </>
            )}
        </Accordion>
    );
};
export default MobileContainer;
